module.exports = __webpack_public_path__ + "static/img/mb-07.830bc20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/mb-07.jpg
// module id = VUJq
// module chunks = 1